import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import { ReliabilityContainer } from '../../containers/ReliabilityContainer';
import { Regions } from '../../containers/Regions';
import { About } from './About';
import { AboutDeveloper } from './internal/components/AboutDeveloper';
import { DeveloperContacts } from './internal/components/DeveloperContacts';

export const AboutContainer: React.FC = () => {
  return (
    <About
      aboutDeveloper={<AboutDeveloper />}
      contacts={<DeveloperContacts />}
      regions={<Regions />}
      reliable={
        <Responsive desktop>
          <ReliabilityContainer />
        </Responsive>
      }
    />
  );
};
